<template>
  <div class="toast-message" :class="[{ active: toast.show }, toast.type]">
    {{ toast.message }}
  </div>
</template>

<script>
export default {
  name: "VueToast",
  props: {
    toast: {
      type: Object,
      required: true,
      default: () => ({ show: false, type: "", message: "" }),
    },
  },

  watch: {
    'toast.show': {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          setTimeout(() => {
            this.$emit("update:toast", { ...this.toast, show: false });
          }, 10000);
        }
      },
    },
  },
};
</script>

<style scoped lang="scss">
.toast-message {
  position: absolute;
  right: 25px;
  bottom: 25px;

  padding: 5px 15px;
  border-radius: 3px;
  font-size: 14px;

  opacity: 0;
  transform: translateY(25%);
  transition: all 0.3s ease;
  z-index: 10000;

  &.active {
    opacity: 1;
    transform: translateY(0);
  }

  &.error {
    background: var(--error-message);
    color: var(--light-text);
  }

  &.success {
    background: var(--success-message);
    color: var(--light-text);
  }

  &.warning {
    background: var(--warning-message);
    color: var(--dark-text);
  }
}
</style>